import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../../components/label/screen-label/screenLabel";
import Loader from '../../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import moment from "moment";
import { displayErrorToast, isEmpty, isNull } from "../../../../utils/Utils";
import { contactUsMessageListRequest } from '../../../../redux/contact-us/contactUs.action'
import Modal from 'react-bootstrap/Modal';

const AdminContactUsList = props => {
    const { contactUsMessageListSuccess, contactUsMessageListError } = useSelector(state => state.contactUs)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const [emptyFieldCounter, setEmptyFieldCounter] = useState(0)
    const [searchQuery, setSearchQuery] = useState('')
    const [selectedRecord, setSelectedRecord] = useState(null)
    const [showMessageModal, setShowMessageModal] = useState(false)

    useEffect(() => {
        fetchContactUsRecord()
    }, [])

    const fetchContactUsRecord = () => {
        setLoading(true)
        const data = {}
        if (!isEmpty(searchQuery)) {
            data.searchQuery = searchQuery
        }
        dispatch(contactUsMessageListRequest(data))
    }

    const handleSearchClick = () => {
        if (isEmpty(searchQuery)) {
            if (Number(emptyFieldCounter) < 3) {
                let currentCounter = emptyFieldCounter
                setEmptyFieldCounter(currentCounter + 1)
                fetchContactUsRecord()
            } else {
                displayErrorToast('Please try refreshing the page.')
            }
        } else {
            fetchContactUsRecord()
        }
    }

    useEffect(() => {
        if (!isEmpty(contactUsMessageListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(contactUsMessageListError)) {
            setLoading(false)
        }
    }, [contactUsMessageListSuccess, contactUsMessageListError])

    const handleViewDetail = (item) => {
        setSelectedRecord(item)
        setShowMessageModal(true)
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='ContactUs Messages' />
                <div className="ol-search-parent-container">
                    <div className="ol-search-row-parent-container">
                        <div className="ol-search-input-container">
                            <input type="text" className="ol-input-no-border" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search" />
                        </div>
                        <div className="ol-search-icon-container" onClick={() => { handleSearchClick() }}>
                            <img src={require('../../../../assets/ic_search_orange.png')} className="img" />
                        </div>
                    </div>
                </div>
                {!isNull(contactUsMessageListSuccess) && !isEmpty(contactUsMessageListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Email</th>
                                <th scope="col" className="text-center">Mobile</th>
                                <th scope="col" className="text-center">Date</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contactUsMessageListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.name}</td>
                                    <td className="text-center">{element.email}</td>
                                    <td className="text-center">{element.phoneNumber}</td>
                                    <td className="text-center">{moment(element.createdOn).utc().format('DD MMM YYYY')}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewDetail(element) }}><div className="tr-action-btn">View Message</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(contactUsMessageListError) && <div className="content-error">{contactUsMessageListError.message}</div>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowMessageModal(false) }}
                show={showMessageModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Message
                </Modal.Header>
                <Modal.Body>
                    {!isEmpty(selectedRecord) && <div className="cul-message-container">
                        <p className="cul-mm-name">{selectedRecord.name}</p>
                        <p className="cul-mm-number">{selectedRecord.phoneNumber}</p>
                        <p className="cul-mm-number">{selectedRecord.email}</p>
                        <p className="cul-mm-message">{selectedRecord.message}</p>
                    </div>}
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AdminContactUsList